import React from 'react'
import BackgroundImage from '../assets/background.png';

function Whatwedo() {
  return (
    <div className="h-screen bg-center bg-cover" style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <div className="flex flex-col items-center justify-center h-full text-white">
        <h1 className="mb-8 text-4xl font-bold md:mb-16">WHAT WE DO</h1>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <Card title="IMPORT"  text="We source the finest electronic home appliances from leading manufacturers in China and India." />
          <Card title="BUY"  text="We purchase high-quality products to ensure the best value for our customers." />
          <Card title="DISTRIBUTE"  text="Our extensive network ensures swift and reliable delivery across Sri Lanka." />
          <Card title="SALE"  text="We offer a wide range of electronic appliances at competitive prices." />
        </div>
      </div>
    </div>
  )
}

const Card = ({ title, icon, text }) => (
    <div className="flex flex-col items-center max-w-sm p-2 mx-auto text-gray-800 bg-white rounded-lg shadow-md md:p-6">
      
      <h2 className="mb-2 text-xl font-bold">{title}</h2>
      <p className="text-center">{text}</p>
    </div>
  );

export default Whatwedo